import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M13.815 9.03c.817 0 1.485.668 1.485 1.485A1.49 1.49 0 0 1 13.815 12H9.36V9.03z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.848 1c3.203 0 4.805 0 6.029.623a5.72 5.72 0 0 1 2.5 2.5C23 5.347 23 6.949 23 10.153v3.695c0 3.203 0 4.805-.623 6.029a5.72 5.72 0 0 1-2.5 2.5c-1.224.623-2.826.623-6.03.623h-3.695c-3.203 0-4.805 0-6.029-.623a5.72 5.72 0 0 1-2.5-2.5C1 18.653 1 17.051 1 13.847v-3.695c0-3.203 0-4.805.623-6.029a5.72 5.72 0 0 1 2.5-2.5C5.347 1 6.949 1 10.153 1zM6.28 18.05h3.08v-2.97h3.693l2.027 2.97h3.3l-2.404-3.512a4.58 4.58 0 0 0 2.404-4.023 4.565 4.565 0 0 0-2.817-4.218 4.6 4.6 0 0 0-1.748-.347H6.28z"
            fill="currentColor"
        />
    </svg>
));
RabotaByAppSolidSize24Glyph.displayName = 'RabotaByAppSolidSize24Glyph';
